import { get, post } from '@/api/http'

// 登陆
export function Login(params) {
  return post('/auth/auth/login', params)
}
export function getPubKey(params) {
  return get('/auth/auth/getPubKey', params)
}
// 退出登录
export function Logout(params) {
  return post('/auth/auth/logout', params)
}
// 发送短信
export function sendMessage(params) {
  return post('/auth/sms/sendMessage', params)
}
// 公司信息注册
export function registerUser(params) {
  return post('/auth/auth/registerUser', params)
}
// 注册信息验证是否重复
export function checkInfo(params) {
  return post('/system/pUser/checkRegisterData', params)
}
// // 保存公司基本信息
// saveComInfo(params) {
//   return post('/auth/auth/registerComp', params)
// }
// 修改密码
export function updatePassword(params) {
  return post('auth/auth/updatePassword', params)
}
// 查询用户信息
export function getUserInfo(params) {
  return post('system/pUser/getUserInfo', params)
}
